import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import ContactFormSection from '../components/ContactFormSection';
import { MapPin, Mail, Clock } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function ContactPage() {
  const { t } = useLang();
  const offices = [
    {
      city: 'Downtown Toronto',
      addr: '',
      region: 'Toronto, ON M5A 0K9',
      mail: 'info@wysetribe.ca',
      hours: 'Mon–Fri, 9am–6pm',
    },
    {
      city: 'Calgary',
      addr: '246 Stewart Green SW, Unit #6319',
      region: 'Calgary, AB, T3H 3C8',
      mail: 'info@wysetribe.ca',
      hours: 'Mon–Fri, 9am–6pm',
    },
  ];

  return (
    <>
      <Header />
      <PageHeader title={t('page.contact')} breadcrumb={[t('page.crumb.contact')]} />

      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          {offices.map((o) => (
            <div key={o.city} className="rounded-xl border border-neutral-100 p-7 bg-[#faf6ec] hover:shadow-[0_25px_55px_-25px_rgba(20,17,15,0.25)] hover:-translate-y-1.5 transition-all group">
              <div className="w-14 h-14 rounded-lg bg-[#f5b300] flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <MapPin className="w-6 h-6 text-[#14110f]" />
              </div>
              <h3 className="text-[22px] font-extrabold text-[#14110f]">{o.city}</h3>
              {o.addr && <p className="text-[14px] text-neutral-600 mt-2">{o.addr}</p>}
              <p className="text-[14px] text-neutral-600">{o.region}</p>
              <div className="mt-5 space-y-2.5 text-[13.5px]">
                <p className="flex items-center gap-2 text-[#14110f]"><Mail className="w-4 h-4 text-[#c89200]" /> {o.mail}</p>
                <p className="flex items-center gap-2 text-[#14110f]"><Clock className="w-4 h-4 text-[#c89200]" /> {o.hours}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="section-eyebrow mb-4">{t('contact.eyebrow')}</p>
            <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
              {t('contact.titlePre')} <span className="text-[#f5b300]">{t('contact.titleAccent')}</span>
            </h2>
            <p className="mt-5 text-[15.5px] text-neutral-600 leading-relaxed">{t('contact.desc')}</p>
            <div className="mt-8 rounded-xl overflow-hidden shadow-[0_25px_60px_-25px_rgba(20,17,15,0.25)]">
              <iframe
                title="WYSE Tribe Calgary office map"
                src="https://maps.google.com/maps?q=246%20Stewart%20Green%20SW%20Calgary&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="320"
                style={{ border: 0 }}
                loading="lazy"
              />
            </div>
          </div>
          <ContactFormSection />
        </div>
      </section>
      <Footer />
    </>
  );
}
